import { render } from "./templates/index.html?vue&type=template&id=488973d2&scoped=true&external"
import script from "./script/index.js?vue&type=script&lang=js&external"
export * from "./script/index.js?vue&type=script&lang=js&external"

import "../AiConsentModal/css/style.css?vue&type=style&index=0&id=488973d2&scoped=true&lang=css&external"
import "./css/index.css?vue&type=style&index=1&id=488973d2&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488973d2"]])

export default __exports__